var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"toast"},[_c('div',{staticClass:"icon"}),_c('p',{staticClass:"msg"},[_vm._v("\n    "+_vm._s(_vm.msg)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }